export const TABLET_STORAGE_KEYS = {
  TABLET_ID: "tablet_id",
  TABLET_PIN: "tablet_pin",
  TABLET_BUILDING_ID: "tablet_building_id",
  VISITOR_PARAM_BUILDING_ID: "visitor_param_building_id",
  VISITOR_PARAM_TABLET_ID: "visitor_param_tablet_id",
  VISITOR_PARAM_TOUCHLESS_PIN: "visitor_param_touchless_pin",
  VISITOR_PARAM_INVITE_ID: "visitor_param_invite_id",
} as const
